import React from 'react';
import LessonView from '../../components/Student/LessonView';

// No s-page wrapper — LessonView owns its full-height layout
const LessonPage = () => <LessonView />;

export default LessonPage;
